// extracted by mini-css-extract-plugin
export default {"container":"TermsAndConditions_container__m+rI-","heading":"TermsAndConditions_heading__7y+u7","markdown":"TermsAndConditions_markdown__tvXI4"};